import { SxProps, Theme } from '@mui/material';

export const modelFiltersStyles = {
  popoverContent: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    marginTop: 2,
    marginLeft: 2,
  } as SxProps<Theme>,

  selectStatus: {
    width: 200,
  } as SxProps<Theme>,

  getAutocompletePopper: (zoomLevel: number) => ({
    width: `${zoomLevel * 300}px !important`,
  }),

  autocompleteTextField: {
    maxWidth: 200,
    '& .MuiInputBase-root': {
      minHeight: '36px',
      height: '36px',
      alignItems: 'center',
      flexWrap: 'nowrap',
    },
    '& .MuiInputBase-input': {
      padding: '7px 14px !important',
      height: 'auto',
      minWidth: '60px',
      flex: '1 1 auto',
    },
    '& .MuiAutocomplete-tag': {
      margin: 0,
      height: '22px',
    },
    '& .MuiAutocomplete-inputRoot': {
      flexWrap: 'nowrap',
      overflow: 'hidden',
    },
  } as SxProps<Theme>,

  preparersTextField: {
    maxWidth: 200,
    '& .MuiInputBase-root': {
      minHeight: '36px',
      height: '36px',
      alignItems: 'center',
      flexWrap: 'nowrap',
      paddingTop: '8px !important',
    },
    '& .MuiInputBase-input': {
      padding: '7px 14px !important',
      height: 'auto',
      minWidth: '60px',
      flex: '1 1 auto',
    },
    '& .MuiAutocomplete-tag': {
      margin: 0,
      height: '22px',
    },
    '& .MuiAutocomplete-inputRoot': {
      flexWrap: 'nowrap',
      overflow: 'hidden',
    },
  } as SxProps<Theme>,

  getTagsContainer: (valueLength: number) => ({
    display: 'flex',
    alignItems: 'center',
    gap: 0.5,
    flexWrap: 'nowrap',
    maxWidth: valueLength > 2 ? '90px' : '100px',
    overflow: 'hidden',
    height: '22px',
    maxHeight: '22px',
    flexShrink: 0,
    marginRight: 0.5,
  }),

  avatar: {
    width: 22,
    height: 22,
    fontSize: '0.65rem',
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  } as SxProps<Theme>,

  chip: {
    height: 22,
    fontSize: '0.65rem',
    flexShrink: 0,
    padding: '0 5px',
    '& .MuiChip-label': {
      padding: '0 2px',
      lineHeight: 1.2,
    },
  } as SxProps<Theme>,

  autocompleteRoot: {
    minWidth: 200,
    '& .MuiAutocomplete-inputRoot': {
      flexWrap: 'nowrap !important',
      '& .MuiAutocomplete-tag': {
        margin: '2px 4px 2px 0',
      },
    },
  } as SxProps<Theme>,

  optionListItem: {
    padding: 0,
  },

  optionCheckbox: {
    marginRight: 8,
  },
};

